export enum DocumentType {
  Report = 'Report',
  System = 'System',
  WorkPaper = 'Work Paper',
  Support = 'Support',
  Source = 'Source',
  RawData = 'Raw Data',
}
